import Decimal from 'decimal.js'

const priceFixedDecimals = (price: number, decimals: number = 2): string => {
	return new Decimal(price).toFixed(decimals, 3)
}

export { priceFixedDecimals }
